import React from 'react';
import heroIcon from '../images/hero icon.png';

export const Hero = () => {
  return (
    <header className="relative min-h-screen w-full flex items-center justify-center overflow-hidden pt-20">
      {/* Background Shapes */}
      <div className="absolute top-0 right-0 w-3/4 h-full bg-halftone transform -skew-x-12 translate-x-1/4 z-0 border-l-4 border-black"></div>
      <div className="absolute bottom-0 left-0 w-1/2 h-1/2 bg-neutral-900 transform skew-y-6 translate-y-20 z-0 border-t-4 border-white"></div>

      {/* Decorative Lines */}
      <div className="absolute top-1/4 left-0 w-full h-2 bg-white transform -rotate-3 z-0"></div>
      <div className="absolute top-3/4 right-0 w-full h-1 bg-black transform rotate-2 z-0"></div>

      <div className="container mx-auto px-4 relative z-10 grid md:grid-cols-2 gap-12 items-center">
        {/* Left: Text Content */}
        <div className="flex flex-col items-start space-y-8 animate-enter-left">
          {/* Date/Tag */}
          <div className="bg-black text-white px-4 py-1 transform -skew-x-12 border border-white inline-block mb-4 rotate-2 shadow-[4px_4px_0px_#D92323] cursor-pointer hover:bg-white hover:text-black transition-colors">
            <span className="font-bold text-sm tracking-widest uppercase transform skew-x-12 flex items-center gap-2">
              Download Now
              <iconify-icon icon="logos:google-play-icon" width="18"></iconify-icon>
            </span>
          </div>

          {/* Main Headline */}
          <div className="relative">
            <h2 className="font-anton text-7xl md:text-9xl uppercase leading-[0.85] text-shadow-hard transform -rotate-2">
              <span className="text-white">Cutthroat</span><br />
              <span className="bg-gradient-to-r from-yellow-400 to-yellow-600 bg-clip-text text-transparent">Dominoes</span><br />
              <span className="bg-red-600 text-white px-2 inline-block h-[0.9em] leading-[0.9em] translate-y-[-0.1em]">Master</span>
            </h2>
            {/* Floating abstract star */}
            <div className="absolute -top-12 -right-12 text-yellow-400 animate-pulse-slow hidden md:block">
              <iconify-icon icon="solar:star-fall-bold" width="80"></iconify-icon>
            </div>
          </div>

          <p className="font-marker text-xl md:text-2xl text-gray-200 bg-black/80 p-4 transform rotate-1 max-w-md border-l-4 border-yellow-400">
            The ultimate All Fives dominoes experience — built for serious players who play to win.
          </p>

          {/* CTA Button */}
          <div className="pt-4 transform hover:scale-105 transition-transform duration-200">
            <button className="relative group bg-transparent border-none p-0 cursor-pointer">
              <div className="absolute inset-0 bg-black translate-x-2 translate-y-2 clip-slant-right"></div>
              <div className="relative bg-gradient-to-r from-yellow-400 to-yellow-600 text-white px-10 py-5 clip-slant-right border-2 border-black group-hover:bg-white group-hover:text-black transition-colors">
                <span className="font-anton text-2xl tracking-wide uppercase flex items-center gap-2">
                  Enter The Arena
                  <iconify-icon icon="solar:arrow-right-linear" width="24"></iconify-icon>
                </span>
              </div>
            </button>
          </div>
        </div>

        {/* Right: Dynamic Visual */}
        <div className="relative hidden md:flex items-center justify-center animate-enter-right">
          {/* Hero Icon Frame */}
          <div className="relative w-96 h-96 bg-black border-4 border-white transform rotate-3 p-3 box-shadow-hard">
            <div className="absolute -top-6 -left-6 bg-yellow-400 text-black font-anton px-4 py-2 transform -rotate-12 border-2 border-black z-20 shadow-[4px_4px_0px_#fff]">
              NEW CHALLENGER!
            </div>

            {/* Inner frame with hero icon + bracket corners */}
            <div className="w-full h-full relative overflow-hidden border-2 border-yellow-400/40 group">
              {/* Hero Icon Image */}
              <img
                src={heroIcon}
                alt="Hero Icon"
                className="w-full h-full object-cover"
              />
              {/* Bracket Corner — Top Left */}
              <div className="absolute top-3 left-3 w-10 h-10 border-t-4 border-l-4 border-yellow-400 z-20 pointer-events-none"></div>
              {/* Bracket Corner — Top Right */}
              <div className="absolute top-3 right-3 w-10 h-10 border-t-4 border-r-4 border-yellow-400 z-20 pointer-events-none"></div>
              {/* Bracket Corner — Bottom Left */}
              <div className="absolute bottom-3 left-3 w-10 h-10 border-b-4 border-l-4 border-yellow-400 z-20 pointer-events-none"></div>
              {/* Bracket Corner — Bottom Right */}
              <div className="absolute bottom-3 right-3 w-10 h-10 border-b-4 border-r-4 border-yellow-400 z-20 pointer-events-none"></div>
              {/* Center crosshair diamond */}
              <div className="absolute inset-0 flex items-center justify-center z-10 pointer-events-none">
                <div className="w-3 h-3 bg-yellow-400 rotate-45 opacity-80"></div>
              </div>
              {/* Scanline overlay */}
              <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/10 to-black/40 z-10 pointer-events-none"></div>
            </div>
          </div>

          {/* Floating Elements */}
          <div className="absolute -bottom-10 -left-12 bg-white text-black p-4 border-2 border-black transform -rotate-6 z-30 max-w-xs">
            <div className="flex items-center gap-3">
              <iconify-icon icon="solar:cup-star-bold" className="text-yellow-400 text-3xl"></iconify-icon>
              <div>
                <div className="font-anton text-lg uppercase leading-none">PLAY NOW</div>
                <div className="font-mono text-xs">Tables Open 24/7</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
